module.exports = __webpack_public_path__ + "img/flow-icon1-6.c9c01570.png";